import { createRootRoute, redirect } from "@tanstack/react-router";

import { RootLayout } from "@/components/Layout/RootLayout";
import { announcementRegistry } from "@/features/announcements/announcementRegistry";
import { Announcements } from "@/features/announcements/Announcements";
import { DEFAULT_ROUTE } from "@/routes/defaultRoute";

/* eslint-disable @typescript-eslint/only-throw-error */

const TOKEN_KEY = "sunner_auth_token";
const TOKEN_EXPIRY_KEY = "sunner_auth_token_expiry";

const isAuthenticated = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  const expiryTime = localStorage.getItem(TOKEN_EXPIRY_KEY);

  if (!token || !expiryTime) {
    return false;
  }

  // Verificar si el token ha expirado
  if (Date.now() > parseInt(expiryTime, 10)) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_EXPIRY_KEY);
    return false;
  }

  return true;
};

export const rootRoute = createRootRoute({
  component: () => (
    <>
      <RootLayout />
      <Announcements registry={announcementRegistry} />
    </>
  ),
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
  }),
  beforeLoad: ({ location }) => {
    const isTestMode =
      (globalThis as Record<string, unknown>).__TEST_MODE__ === true;
    if (isTestMode) {
      return;
    }

    const isPublicRoute = location.pathname.startsWith("/login");
    const authenticated = isAuthenticated();

    if (!authenticated && !isPublicRoute) {
      throw redirect({
        to: "/login",
        ...(location.pathname !== "/" && {
          search: { redirect: location.href },
        }),
      });
    }

    if (authenticated && (location.pathname === "/" || isPublicRoute)) {
      throw redirect({ to: DEFAULT_ROUTE });
    }
  },
});
